import React from 'react'
import { Link } from 'react-router-dom'
import SectionTitle from './../../../../components/section_title/SectionTitle'
import PlayerHead from './../../../../components/player_head/PlayerHead'
import {
    getPlayerURL,
    getTeamNameById,
    getPlayerImageURL,
} from './../../../../utils/js/shared_helpers'
import { preserveQueryParams } from 'utils/js/browser_helpers'
import NoDataMessage from './../no_data_message/NoDataMessage'

import './Teammates.scss'

const Teammates = ({ teammates, league, sport, teamId }) => {
    if (!teammates || !teamId) return null

    const teamNameUrl = getTeamNameById(teamId, league)

    return (
        <div className="Teammates__cont">
            <SectionTitle title="TEAMMATES" />

            <div className="teammates_inner_cont">
                {teammates.length !== 0 && (
                    <React.Fragment>
                        {teammates.map((teammate, i) => {
                            if (i > 5) return null

                            let player_url = getPlayerURL(teammate.first_name, teammate.last_name, teammate.player_id)

                            return (
                                <a href={preserveQueryParams(player_url)} key={teammate.player_id}>
                                    <div className="player_cont">
                                        <div className="player_face">
                                            <PlayerHead
                                                imageUrl={getPlayerImageURL(
                                                    teammate.player_id,
                                                    'xs'
                                                )}
                                                imageWidth={30}
                                                animate={false}
                                            />
                                        </div>
                                        <div className="player_name">
                                            {teammate.first_name} {teammate.last_name}
                                        </div>
                                    </div>
                                </a>
                            )
                        })}

                        <div className="roster_link">
                            <Link
                                to="#"
                                onClick={() => {
                                    const newPathName = preserveQueryParams(
                                        `/${sport}/${league}/teams/${teamNameUrl}/?tab=roster`
                                    )
                                    window.location.href = `${window.location.origin}${newPathName}`
                                }}
                            >
                                Full Roster
                            </Link>
                        </div>
                    </React.Fragment>
                )}

                {teammates.length === 0 && <NoDataMessage />}
            </div>
        </div>
    )
}

export default Teammates
